export default {
  background: require('../assets/images/bg.png'),
  branding: {
    invilliaApps: require('../assets/images/branding/invillia-apps.svg'),
    inStation: require('../assets/images/branding/logo-invillia-instation.svg'),
    invillia: require('../assets/images/branding/icon-invillia-color.svg'),
    invilliaWhite: require('../assets/images/branding/icon-invillia-white.svg'),
  },
  inStationMap: require('../assets/images/instation-map.png'),
  permission: require('../assets/images/img-permissions.png'),
  microsoftTeams: require('../assets/images/img-teams.png'),
  tiles: {
    footerLeft: require('../assets/images/tiles-footer-left.svg'),
    footerRight: require('../assets/images/tiles-footer-right.svg'),
    leftFirstSection: require('../assets/images/tiles-left-first-section.svg'),
  },
  icons: {
    instation: require('../assets/images/icons/ico-btn-instation.svg'),
    microsoft: require('../assets/images/icons/ico-btn-microsoft.svg'),
    teams: require('../assets/images/icons/ico-btn-teams.svg'),
    openMenu: require('../assets/images/icons/ico-menu-01.svg'),
    closeMenu: require('../assets/images/icons/ico-menu-02.svg'),
    unchecked: require('../assets/images/icons/ico-check.png'),
    checked: require('../assets/images/icons/ico-checked.png'),
    information: require('../assets/images/icons/ico-information.svg'),
    alert: require('../assets/images/icons/ico-alert.svg'),
  },
};
